import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const StageGateDatepicker = lazy(() =>
  import(/* webpackChunkName: "StageGateDatepicker" */ '../../components/survey_editor/stage_gate/StageGateDatepicker')
);

export default function StageGateDatepickerComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <StageGateDatepicker {...props} />
    </Suspense>
  );
}
